<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<p-dialog *ngIf="dialogData"
          [header]="dialogData.dialogHeader"
          [(visible)]="isVisible"
          [responsive]="true"
          [modal]="true"
          [closable]="false">
  <p>{{dialogData.dialogMessage}}</p>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="flat" (click)="defaultHideDialog()" [label]="dialogData.cancelLabel" data-testid="dialog-data-cancel-label-btn"></button>

    <button pButton type="button" (click)="defaultAcceptDialog()" class="mr-none" [label]="dialogData.acceptLabel" data-testid="dialog-data-accept-label-btn"></button>
  </ng-template>
</p-dialog>


